/**
 * App — Root Component with Router Configuration.
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LoginPage from '@/features/auth/pages/LoginPage';
import RegisterPage from '@/features/auth/pages/RegisterPage';
import DashboardLayout from '@/layouts/DashboardLayout';
import DashboardHome from '@/features/dashboard/pages/DashboardHome';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import SettingsPage from '@/features/settings/pages/SettingsPage';
import MarketPage from '@/features/market/pages/MarketPage';
import OrdersPage from '@/features/orders/pages/OrdersPage';
import StrategiesPage from '@/features/strategies/pages/StrategiesPage';
import RiskEnginePage from '@/features/risk/pages/RiskEnginePage';
import AnalyticsPage from '@/features/analytics/pages/AnalyticsPage';
import FundsPage from '@/features/funds/pages/FundsPage';
import PortfolioPage from '@/features/portfolio/pages/PortfolioPage';
import OptionChainPage from '@/features/options/pages/OptionChainPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard" element={<DashboardHome />} />
              {/* Phase 3-4 */}
              <Route path="/trading" element={<OrdersPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/market" element={<MarketPage />} />
              <Route path="/options" element={<OptionChainPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/strategies" element={<StrategiesPage />} />
              <Route path="/funds" element={<FundsPage />} />
              <Route path="/risk" element={<RiskEnginePage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
          </Route>

          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}


